import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=a1a516ea"
import script from "./UserPreferences.vue?vue&type=script&lang=ts"
export * from "./UserPreferences.vue?vue&type=script&lang=ts"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&id=a1a516ea&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports